import React from "react";

const VideoPlayerAlert = ({ customStyles }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="7.071"
			height="7.071"
			viewBox="0 0 7.071 7.071"
			style={{ ...customStyles }}
		>
			<rect id="alert" width="5" height="5" transform="translate(3.536) rotate(45)" fill="#eb0b0b" />
		</svg>
	);
};

export default VideoPlayerAlert;
